module.exports = __webpack_public_path__ + "img/spinner.016ea644.gif";